<template>
  <!-- Componente de carga -->
  <div class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75 z-50">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: "AppLoding",
  props: {
  },
};
</script>

<style scoped>
.loader {
  border: 5px solid #01437f; /* Light grey */
  border-top: 5px solid #f97316; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 4s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>